import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icons-social-youtube-dda7f",
  "use": "icons-social-youtube-dda7f-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 16 16\" id=\"icons-social-youtube-dda7f\"><path d=\"M12 1.6H4a4 4 0 0 0-4 4v4.8a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4V5.6a4 4 0 0 0-4-4m-.568 6.88-4.909 2.891a.546.546 0 0 1-.819-.48V5.104a.546.546 0 0 1 .82-.48l4.908 2.896a.553.553 0 0 1 0 .96\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol